<template>
  <div class="payments">
    <div>
      <div class="header"></div>
      <div class="section">
        <div class="container">
          <div>
            <h2>有料プラン申込</h2>
            <div class="main-area">
              <div>
                1契約&nbsp;年額<span class="price-large">5,000</span
                >円（税込<span class="price-normal">5,500</span>円）
              </div>
            </div>
            <div class="sub-area">
              <ul>
                <li>
                  ※お支払い方法、お支払時期、解約については<a
                    href="https://www.ricelog.com/sct.html"
                    target="_blank"
                    >こちら</a
                  >をご確認ください。
                </li>
                <li>
                  ※お申込み時点で<a
                    href="https://www.ricelog.com/service.html"
                    target="_blank"
                    >利用規約</a
                  >と<a href="https://www.sgnet.co.jp/security/" target="_blank"
                    >個人情報保護方針</a
                  >に同意したことになります。
                </li>
              </ul>
            </div>
            <div
              id="message-area"
              class="error-message mdi mdi-alert-circle-outline"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </div>
            <div
              id="message-area"
              class="information-message mdi mdi-check-circle-outline"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="card-area" :class="{ complete: cardInput }">
              <div ref="payjpArea"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";

export default {
  data() {
    return {
      cardInput: false,
      errorMessage: null,
      message: null,
    };
  },

  mixins: [Loader],
  components: {},
  created() {},
  mounted() {
    this.$emit("hideMap");
    this.cardInput = false;
    this.appendPayJpScriptTag();
    window.onTokenCreated = this.onTokenCreated;
    window.onTokenFailed = this.onTokenFailed;
  },

  beforeDestroy() {
    this.destoryPayjp();
  },

  methods: {
    ...mapActions(["createSubscription", "showAccount", "showAccountID"]),
    ...mapGetters(["getAccountID"]),

    appendPayJpScriptTag() {
      const attrs = {
        "data-key": "pk_live_18e8ee952a741311e2c7e57f",
        id: "payjp-script",
        src: "https://checkout.pay.jp/",
        class: "payjp-button",
        "data-partial": true,
        "data-text": "有料プラン申込",
        "data-submit-text": "有料プラン申込",
        "data-lang": "ja",
        "data-on-created": "onTokenCreated",
        "data-on-failed": "onTokenFailed",
        "data-name-placeholder": "",
      };
      this.scriptEl = document.createElement("script");
      for (let key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key]);
      }
      this.$refs.payjpArea.appendChild(this.scriptEl);
    },
    onTokenCreated() {
      this.loading(async () => {
        let token = document.getElementsByName("payjp-token")[0].value;
        this.cardInput = true;
        try {
          const ret = await this.createSubscription({ token: token });
          if (ret.status === 201) {
            this.message = "既に申込済みです。";
          } else {
            this.message = "申込が完了いたしました。";
          }
        } catch (err) {
          this.errorMessage =
            "申込ができませんでした。再度申込を行なってください。";
          return;
        }

        // 更新後のアカウント情報
        await this.showAccount(await this.showAccountID());
      });
    },
    onTokenFailed(res) {  // eslint-disable-line no-unused-vars
      // 処理
      this.errorMessage =
        "カード情報の読み込みに失敗しました。再度申込を行なってください。";
    },

    onAddSubscription() {},

    destoryPayjp() {
      const payjpCheckoutIframeEl = document.getElementById(
        "payjp-checkout-iframe"
      );
      payjpCheckoutIframeEl.parentElement.remove();
      this.$refs.payjpArea.removeChild(this.scriptEl);
      window.PayjpCheckout = null;
      window.onTokenCreated = null;
      window.onTokenFailed = null;
    },
  },
};
</script>

<style lang="scss">
.payments {
  .header {
    margin: 2rem;
  }
  .section {
    overflow: auto;
    width: 70%;
    height: calc(100% - 130px);
    position: relative;
    margin: auto;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
        font-size: 1.5rem;

        .price-large {
          font-size: 3rem;
          margin: 1rem;
        }
        .price-normal {
          font-weight: 700;
          margin: 0.5rem;
        }
      }

      .sub-area {
        ul {
          list-style-type: none;
        }

        a {
          margin: 0.5rem;
        }
      }
    }
  }
  .card-area {
    text-align: center;
    margin: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin: 2rem;
  }
}
</style>
